import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-397c642a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ecran-container",
  style: {"min-height":"75vh"}
}
const _hoisted_2 = {
  key: 0,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_3 = { class: "app__color--label q-ma-md" }
const _hoisted_4 = { style: {"white-space":"nowrap","font-size":"2rem"} }
const _hoisted_5 = { class: "dashboard__div__content app__border__bottom" }
const _hoisted_6 = { class: "absolute-full flex flex-center bg-negative text-white text-subtitle2" }
const _hoisted_7 = {
  class: "dashboard__div__parameter",
  style: {"grid-area":"nume"}
}
const _hoisted_8 = { class: "app__property--medium" }
const _hoisted_9 = {
  class: "dashboard__div__parameter",
  style: {"grid-area":"prenume"}
}
const _hoisted_10 = { class: "app__property--medium" }
const _hoisted_11 = {
  class: "dashboard__div__parameter",
  style: {"grid-area":"functie"}
}
const _hoisted_12 = {
  class: "dashboard__div__parameter",
  style: {"grid-area":"telefon"}
}
const _hoisted_13 = {
  class: "dashboard__div__parameter email",
  style: {"grid-area":"email"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$q.platform.is.desktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_q_icon, {
                name: "people",
                style: {"font-size":"2rem","margin-top":"-5px"},
                color: "primary"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.users')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "dashboard__section",
        key: user.appid
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_q_avatar, {
            size: "7rem",
            style: {"grid-area":"avatar","margin-right":"1rem"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_img, {
                src: user.urlUserImgProfileByAppid,
                style: {"height":"7rem","max-width":"7rem"}
              }, {
                error: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('message.no_image')), 1)
                ]),
                _: 2
              }, 1032, ["src"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(user.firstName), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(user.lastName), 1)
          ]),
          _createElementVNode("div", _hoisted_11, _toDisplayString(user.functie), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(user.phoneNr), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(user.email), 1)
        ])
      ]))
    }), 128))
  ]))
}